// i18n area 'apps' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.pl-PL.meta.json.
import type { enUS } from './apps'

export const plPL: typeof enUS = {

  // Apps fala 1 (Annex R): zarządzane kontenery podman — nadzorowane przez
  // workera na zadeklarowanym węźle; obraz = lockfile branch@digest (Annex Q)
  // z polityką pinned/tracking; podłączenie L3 untagged ze statycznym IP.
  apps: {
    title: 'Aplikacje',
    create: 'Utwórz aplikację',
    createTitle: 'Utwórz aplikację',
    editTitle: 'Edytuj aplikację',
    name: 'Nazwa',
    nameHint: 'DNS-1123, unikalna w obrębie scope — niezmienna po utworzeniu.',
    node: 'Węzeł',
    nodeHint: 'Węzeł członkowski, który ją obsługuje — jawny placement (scheduler pojawi się później).',
    image: 'Obraz',
    editImageHint: 'Nowe odwołanie jest rozwiązywane od nowa przez ewidencję — to gest pin/rollback.',
    imagePolicy: 'Polityka',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest zmienia się wyłącznie na polecenie.',
    policyTrackingHint: 'Automatyczny rolling, gdy refresh przesunie brancha.',
    archMovePolicy: 'Przeniesienie cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Co się dzieje, gdy app zostaje przeniesiona na node innej architektury: refuse odrzuca przeniesienie, reresolve ponownie rozwiązuje lockfile z brancha na nowej arch — zawartość się zmienia, a odpowiedź nazywa zmianę digestu.',
    network: 'Sieć',
    networkHint: 'Podłączenie L3 untagged: sieć logiczna fabric (zalecana — gateway/DNS z jej jedynego źródła), sieć overlay albo surowy bridge hosta (odradzany).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'bridge hosta:',
    ipAssignment: 'Przypisanie IP',
    ipStatic: 'Statyczne',
    ipAuto: 'Automatyczne (IPAM)',
    ipAssignmentHint_static: 'Adres podaje się tutaj i teraz.',
    ipAssignmentHint_auto: 'IPAM wybiera wolny adres z zakresów sieci zarezerwowanych dla TVirt.',
    bridgeDiscouraged: 'Surowy bridge hosta — ODRADZANY: TVirt nic nie wie o jego adresacji, więc gateway i DNS trzeba podać ręcznie. Zalecaną drogą jest sieć logiczna fabric.',
    ip: 'IP',
    ipHint: 'Statyczny IPv4 wewnątrz podsieci podłączenia.',
    ipCidrHint: 'W postaci CIDR na surowym bridge (np. 192.168.1.10/24) — nie ma skąd wyprowadzić prefiksu.',
    gateway: 'Gateway',
    gatewayManualHint: 'Ręcznie — surowy bridge niczego nie wyprowadza.',
    dnsServers: 'Serwery DNS',
    dnsManualHint: 'Ręcznie, rozdzielone przecinkami — co najmniej jeden.',
    rootKind: 'Root',
    rootEphemeral: 'efemeryczny',
    rootPersistent: 'trwały',
    rootEphemeralHint: 'Odtwarzany z obrazu przy każdym odtworzeniu; żyje na efemerycznym storage klastra.',
    rootEphemeralHintNamed: 'Odtwarzany z obrazu przy każdym odtworzeniu; żyje na efemerycznym storage klastra ({name}).',
    rootPersistentHint: 'Przeżywa restarty; żyje na wybranym storage.',
    rootStorage: 'Storage roota',
    editRootStorageHint: 'Root zostanie wyrenderowany od nowa w nowej puli — istniejące dane NIE przenoszą się same.',
    volumes: 'Woluminy',
    volumeAdd: 'Dodaj wolumin',
    volumeName: 'Nazwa',
    volumeMountPath: 'Ścieżka montowania',
    volumeKind: 'Typ',
    volumeStorage: 'Storage',
    devices: 'Urządzenia',
    deviceClassHint: 'Prosi się o KLASĘ (tag gpu-device lub usb-device), nigdy o konkretne urządzenie: zadeklarowany węzeł musi mieć takie oznaczone dla Apps. Kilka Apps może używać tego samego urządzenia — kontener je współdzieli, nie odbiera go hostowi.',
    deviceSlot: 'Slot',
    deviceTag: 'Tag',
    deviceValue: 'Klasa',
    deviceUnresolved: 'teraz nic się nie rozwiązuje',
    noDeviceTags: 'Brak jeszcze tagu rodzaju gpu-device lub usb-device: utwórz go i przypisz do urządzeń oznaczonych dla Apps.',
    env: 'Środowisko',
    envHint: 'Jedna para KLUCZ=wartość na wiersz.',
    secretEnvTitle: 'Zmienne sekretne',
    secretEnvNotice: 'Sekretna wartość nigdy nie wraca z API: nikt jej ponownie nie odczyta, nawet ten, kto ją wpisał. W checkpoincie podróżuje zapieczętowana za pomocą masterpass, więc odtworzenie bez masterpass poprosi o ponowne jej wpisanie.',
    secretEnvPromote: 'Uczyń sekretną jedną ze zmiennych wpisanych powyżej:',
    secretEnvAdd: 'Dodaj zmienną sekretną',
    secretEnvName: 'Nazwa',
    secretEnvValue: 'Wartość',
    secretEnvKept: 'zachowana — zostaw puste, aby jej nie zmieniać',
    secretEnvWithdrawWarning: 'Aby przestać traktować jako sekretną zmienną, która już nią jest, wpisz jej nową wartość: samo zdjęcie znacznika byłoby sposobem na ODCZYTANIE tego, co nigdy nie wychodzi ze store. Usunięcie zmiennej natomiast ją kasuje.',
    secretEnvChip: 'sekretne',
    startNow: 'Uruchom od razu (inaczej aplikacja powstanie zatrzymana)',
    deletePersistentIntro: 'Ta aplikacja ma dane trwałe — należy wybrać, co z nimi zrobić:',
    deleteKeepData: 'Zachowaj dane (foldery zostają na swoich storage, osierocone)',
    deletePurgeData: 'Usuń także dane',
    phase: 'Faza',
    phase_running: 'Uruchomiona',
    phase_stopped: 'Zatrzymana',
    phase_error: 'Błąd',
    phase_unknown: 'Nieznana',
    desiredState: 'Żądany',
    wantedRunning: 'uruchomiona',
    wantedStopped: 'zatrzymana',
    start: 'Uruchom',
    stop: 'Zatrzymaj',
    restart: 'Uruchom ponownie',
    refreshImage: 'Odśwież obraz (przyjmij nowy @current)',
    logs: 'Logi',
    logsTitle: 'Logi',
    logsEmpty: 'Nie przechwycono żadnego wyjścia.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App nie jest uruchomiona — shell potrzebuje żywego kontenera. Jej logi można czytać w każdym stanie.',
    shellConnect: 'Połącz',
    shellDisconnect: 'Rozłącz',
    shellExited: 'Sesja zakończyła się kodem wyjścia {code}.',
    shellEndedWithoutStatus: 'Sesja zakończyła się bez statusu wyjścia: {reason}',
    shellRevoked: 'Ticket sesji nie jest już ważny — wygasł albo logowanie, które go otworzyło, zostało odwołane.',
    shellHint: 'Kliknij czarne pole i pisz: klawisze trafiają do kontenera. Ctrl+C i strzałki działają; exit zamyka shell.',
    shellStatus: {
      connecting: 'Łączenie…',
      connected: 'Połączono',
      ended: 'Zakończona'
    },
    deleteRunningError: '{name} ma być uruchomiona — najpierw należy ją zatrzymać.',

    // Dialog standardowy (runda #156): taby szczegółów i brakujące pola
    // contractu — każde pole App widoczne, kłódki z uzasadnieniem.
    tabs: {
      general: 'Ogólne',
      image: 'Obraz',
      network: 'Sieć',
      storage: 'Storage',
      devices: 'Urządzenia',
      observed: 'Obserwowane'
    },
    attachment: 'Podłączenie',
    runningDigest: 'Digest działającego obrazu',
    lastError: 'Ostatni błąd',
    reportObservedAt: 'Ostatni raport workera',
    desiredStateLock: 'Rządzą nim akcje Uruchom/Zatrzymaj — nigdy bezpośrednia edycja.',
    ipEditDisabledHint: 'Edytowalne tylko przy przypisaniu statycznym.',
    derivedFromNetworkHint: 'Wyprowadzone z jedynego źródła sieci — ręcznie tylko na surowym bridge ze statycznym IP.',
    ephemeralUnset: 'nieskonfigurowany',
    ephemeralMissing: 'Efemeryczny storage Aplikacji nie jest skonfigurowany — utworzenie aplikacji z elementami efemerycznymi (root lub woluminy) będzie odrzucane, dopóki nie zostanie ustawiony.',
    ephemeralCurrent: 'Efemeryczny storage Aplikacji: {name}',
    ephemeralMissingCreate: 'Ta aplikacja ma elementy efemeryczne, a efemeryczny storage Aplikacji nie jest ustawiony — utworzenie zostanie odrzucone. Należy go najpierw ustawić z banera na stronie Aplikacje.',
    setEphemeral: 'Ustaw efemeryczny storage',
    changeEphemeral: 'Zmień efemeryczny storage',
    setEphemeralTitle: 'Ustaw efemeryczny storage Aplikacji',
    changeEphemeralTitle: 'Zmień efemeryczny storage Aplikacji',
    ephemeralStorageHint: 'DOMYŚLNA wartość klastra: pula typu dir, na której żyją roots i woluminy efemeryczne każdej aplikacji, o ile aplikacja nie zadeklaruje własnego override. Zmiana nie działa na gorąco i niczego nie restartuje: obowiązuje od następnego startu każdej aplikacji — dane efemeryczne się nie przenoszą.',
    ephemeralPool: 'Pula storage',
    ephemeralOverride: 'Efemeryczny storage (override dla aplikacji)',
    ephemeralOverrideInherit: 'Dziedzicz domyślną wartość klastra',
    ephemeralOverrideInheritNamed: 'Dziedzicz domyślną wartość klastra ({name})',
    ephemeralOverrideHint: 'Własna pula aplikacji dla roota i woluminów efemerycznych — puste pole oznacza dziedziczenie domyślnej wartości klastra. Zmiana nie działa na gorąco i niczego nie restartuje: obowiązuje od następnego startu (dane efemeryczne odradzają się puste w nowej puli) i wymaga uprawnienia app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Wszystkie gałęzie',
    imageBranchHint: 'Zawęża obrazy do tych nazywanych przez tę gałąź; bez gałęzi widać wszystkie obrazy repozytorium.',
    imageDigestHint: 'Treść: wybiera się ją z tabeli digestów, która niesie jej pochodzenie i architekturę. Ta sama gałąź oferuje po jednej na architekturę i nie są one wymienne.',
    imageLockfile: 'Rozwiązane odwołanie',
    imageNoImages: 'Brak obrazów w pamięci podręcznej dla tego repozytorium — pobierz jeden z Obrazów OCI.',
    imageHeadNotCached: 'nie ma w cache — pobierany przy starcie',
    imageNoRegistries: 'Nie zarejestrowano żadnego repozytorium: zarejestruj jedno, aby móc wybrać obraz.',
    imageChosenHint: 'Obraz wybiera się kaskadą w oknie edycji: odwołania nigdy nie wpisuje się ręcznie.',
    registerRepositoryHint: 'Rejestracja niczego nie pobiera: czyni repozytorium obserwowalnym, aby obraz dało się wybrać bez opuszczania tego okna.',
    registerRepositoryBranchHint: 'Opcjonalnie: pierwsza gałąź do obserwowania (np. latest).',
    registerRepositoryElsewhere: 'Szukane repozytorium nie jest zarejestrowane: rejestracja odbywa się w sekcji Obrazy OCI, przez kogoś z uprawnieniem.'
  },

  // Template CT (runda K2 #63): ZMATERIALIZOWANE obiekty CT — import z
  // katalogu to jedyne wejście; pliki wgrywa się do katalogów.
  cts: {
    createAction: 'Utwórz CT',
    createTitle: 'Utwórz kontener z template',
    createError: 'Kontener nie został utworzony',
    template: 'Template CT',
    noTemplates: 'Brak template CT — należy zaimportować jakiś z Template CT',
    resources: 'Zasoby',
    node: 'Węzeł',
    phase: {
      defined: 'Nigdy nieuruchomiony',
      materializing: 'Materializacja',
      ready: 'Gotowy',
      starting: 'Uruchamianie',
      running: 'Działa',
      stopping: 'Zatrzymywanie',
      stopped: 'Zatrzymany',
      deleting: 'Usuwanie',
      error: 'Błąd'
    },
    actions: {
      start: 'Uruchom',
      stop: 'Zatrzymaj',
      restart: 'Uruchom ponownie',
      markTemplate: 'Promuj do template CT',
      error: 'Akcja została odrzucona'
    },
    markTemplate: {
      confirmTitle: "Promować '{name}' do template CT?",
      confirmBody: 'Kontener opuszcza tę listę i przechodzi do Template CT, od razu gotowy do generowania nowych CT. Metadane pozostają edytowalne, a przywrócenie go do CT jest możliwe w każdej chwili.',
      confirm: 'Promuj',
      moved: "'{name}' jest teraz template CT — znajduje się w Template CT."
    },
    stopCause: {
      api: 'Zatrzymany przez TVirt',
      'ct-exit': 'Kontener zakończył się sam',
      'host-reboot': 'Zginął wraz z restartem węzła',
      'start-failed': 'Uruchomienie się nie powiodło — błąd taska mówi, czego brakuje i jak to naprawić'
    },

    console: 'Konsola',
    consoleUnavailable: 'Kontener nie działa — konsola potrzebuje żywego kontenera. Jego logi natomiast czyta się w każdym stanie.',
    consoleNoTemplate: 'Template nigdy nie działa, więc nie ma konsoli: utwórz z niego CT i otwórz jego konsolę.',
    consoleConnect: 'Połącz',
    consoleDisconnect: 'Rozłącz',
    consoleReconnect: 'Połącz ponownie',
    consoleTakenBy: 'Inny operator przejął tę konsolę ({user}). Jedna konsola na kontener: ponowne połączenie odbiera ją z powrotem.',
    consoleHint: 'Kliknij czarne pole i pisz: klawisze docierają do kontenera. Ctrl+C i strzałki działają.',
    consoleEndpointDown: 'Punkt dostępu konsoli nie otwiera się na węźle obsługującym container: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container nie działa — shell potrzebuje żywego containera. Jego logi można czytać w każdym stanie.',
    shellNoTemplate: 'Template nigdy nie działa, więc nie ma shella: utwórz z niego CT i otwórz jego shell.',
    shellConnect: 'Połącz',
    shellDisconnect: 'Rozłącz',
    shellExited: 'Sesja zakończyła się kodem wyjścia {code}.',
    shellEndedWithoutStatus: 'Sesja zakończyła się bez statusu wyjścia: {reason}',
    shellRevoked: 'Ticket sesji nie jest już ważny — wygasł albo logowanie, które go otworzyło, zostało odwołane.',
    shellHint: 'Kliknij czarne pole i pisz: klawisze trafiają do kontenera. Ctrl+C i strzałki działają; exit zamyka shell.',
    shellStatus: {
      connecting: 'Łączenie…',
      connected: 'Połączono',
      ended: 'Zakończona'
    },
    rootPassword: 'Hasło roota',
    rootPasswordHint: 'Zapisywane raz w skopiowanym rootfs (jako hash, nigdy więcej nie pokazywane). Obrazy dystrybucji nie mają hasła roota: bez niego shell jest jedynym wejściem.',
    sshKeys: 'Publiczne klucze SSH roota',
    sshKeysHint: 'Jeden publiczny klucz OpenSSH na wiersz, do root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Łączenie…',
      connected: 'Połączona',
      reconnecting: 'Ponowne łączenie…'
    },
    logs: 'Logi',
    logsTitle: 'Logi',
    logsEmpty: 'Nie przechwycono żadnego wyjścia.',
    logsSource: 'Który log',
    logsSourceConsole: 'Konsola inita kontenera — dlaczego usługa w środku nie wystartowała',
    logsSourceSupervisor: 'Supervisor liblxc — dlaczego kontener nigdy nie doszedł do uruchomienia',
    logsNeverStarted: 'Nigdy nie został uruchomiony, więc nie ma jeszcze nic zapisanego — uruchom go, a logi będą nawet jeśli uruchomienie się nie powiedzie.',
    logsNoTemplate: 'Template nigdy nie działa, więc nigdy nic nie zapisał.',
    logsError: 'Nie udało się przechwycić logów',

    // Dialog standardowy (runda #156): taby szczegółów wspólne dla list CT
    // i Template CT, plus kłódki z uzasadnieniem.
    tabs: {
      general: 'Ogólne',
      hardware: 'Sprzęt',
      network: 'Sieć',
      provenance: 'Pochodzenie'
    },
    templateFlag: 'Template CT',
    templateLock: 'Zmienia się tylko akcjami Promuj / Przywróć do CT — nigdy bezpośrednią edycją.',
    sourceLock: 'Pochodzenie, zapisane w chwili narodzin — nigdy nadpisywane; martwe źródło zostawia gołe odwołanie.',
    storageLock: 'Ustalony przy tworzeniu — przenoszenie rootfs to przyszła runda.',
    startedAt: 'Uruchomiony',
    lastStop: 'Ostatnie zatrzymanie',
    editNicsTitle: 'Edytuj sieci',
    nicDisconnected: 'odłączona'
  },
  ctTemplates: {
    title: 'Template CT',
    importAction: 'Importuj z katalogu',
    importTitle: 'Importuj template CT z katalogu',
    importSubmit: 'Importuj',
    importError: 'Import został odrzucony',
    importHint: 'Materializacja kopiuje rootfs na wybrany storage — plik katalogu pozostaje nietknięty. Aby dodać nowe pliki, trzeba je najpierw wgrać do katalogu.',
    sourceFile: 'Plik template CT',
    sourceFileHint: 'Pliki ct-rootfs z wybranego katalogu, tylko te gotowe',
    noFiles: 'Brak gotowych plików ct-rootfs w tym katalogu — należy wgrać jakiś ze strony katalogu',
    source: 'Plik źródłowy',
    rootfsStorage: 'Storage rootfs',
    rootfsStorageHint: "Gdzie żyje wypakowane drzewo rootfs — storage z systemem plików i wystarczającą ilością wolnego miejsca na rozmiar po wypakowaniu plus około 1 GiB zapasu (inaczej import się nie powiedzie).",
    resources: 'Zasoby',
    cores: 'vCPU',
    memoryMiB: 'Pamięć (MiB)',
    cpuLimit: 'Limit CPU',
    cpuLimitHint: 'Ekwiwalenty rdzeni hosta (np. 1.5); puste = bez limitu',
    cpuUncapped: 'bez limitu',
    cpuWeight: 'Waga CPU',
    hostname: 'Hostname',
    hostnameHint: 'Puste = nazwa CT',
    nameservers: 'Serwery nazw DNS',
    dnsHint: 'Rozdzielone przecinkami; puste = dziedziczy te z hosta',
    searchDomains: 'Domeny przeszukiwania DNS',
    dnsInherited: 'Odziedziczone z hosta',
    networks: 'Sieci',
    nicSlot: 'Slot NIC',
    phase: {
      materializing: 'Materializacja',
      ready: 'Gotowy',
      deleting: 'Usuwanie',
      error: 'Błąd'
    },
    exportAction: 'Eksportuj do katalogu',
    exportTitle: 'Eksportuj do katalogu',
    exportSubmit: 'Eksportuj',
    exportError: 'Eksport został odrzucony',
    exportHint: 'Pakuje zmaterializowany rootfs w NOWY plik ct-rootfs w wybranym katalogu — template pozostaje nietknięty.',
    exportName: 'Nazwa pliku',
    exportNameHint: 'Puste = <template>-export-<n>',
    markCt: {
      action: 'Przywróć do CT',
      confirmTitle: "Przywrócić '{name}' do CT?",
      confirmBody: 'Template opuszcza tę listę i wraca na listę CT, znów gotowy do uruchomienia. Dopóki nie zostanie ponownie promowany, nie można z niego tworzyć CT.',
      confirm: 'Przywróć do CT',
      moved: "'{name}' jest znów CT — znajduje się na liście CT."
    }
  },

  // OCI fala 1 (Annex Q — model tag-jako-branch): tag OCI to branch
  // (ruchomy wskaźnik), digest to commit; refresh = "git fetch",
  // pull = rozwiąż TERAZ, pobierz TEN digest.
  oci: {
    registriesTitle: 'Registry OCI',
    imagesTitle: 'Obrazy OCI',
    provider: 'Dostawca',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Ogólny',
    providerImmutableHint: 'Dostawca jest niezmienny po utworzeniu — inny dostawca to nowe registry.',
    url: 'URL',
    urlHintPreset: 'Wypełniony z góry przez dostawcę — nadpisywać tylko dla mirrorów.',
    urlHintRequired: 'Obowiązkowy dla ogólnych registry: bazowy URL https://.',
    urlHintEcr: 'Obowiązkowy: endpointy ECR są per konto i per region — nie ma gotowej wartości.',
    credential: 'Poświadczenie',
    credentialNone: 'Dostęp anonimowy',
    credentialHint: 'Wpis keystore typu użytkownik i hasło; workery rozwiązują go w chwili użycia — nigdy plik auth na każdym węźle.',
    nameHint: 'Nazwa w formie hosta (docker.io, registry.intra); unikalna w scope, niezmienna',
    addRegistry: 'Dodaj registry',
    addRegistryTitle: 'Dodaj registry OCI',
    verify: 'Zweryfikuj',
    verifyState: 'Weryfikacja',
    verified: 'Zweryfikowane',
    verifyFailed: 'Nieudana',
    neverVerified: 'Nigdy nieweryfikowane',
    registryInUseError: "'{name}' ma jeszcze zarejestrowane repozytoria — najpierw trzeba je usunąć.",
    repositories: 'Repozytoria',
    repositoriesHint: 'Rejestracja obserwuje branche (tagi OCI) — niczego nie pobiera. Refresh rozwiązuje każdego obserwowanego brancha i utrzymuje reflog.',
    noRepositories: 'Brak repozytoriów zarejestrowanych w tym registry.',
    registerRepository: 'Zarejestruj repozytorium',
    repoPath: 'Ścieżka',
    repoPathHint: "Ścieżka repozytorium w registry, np. 'example' lub 'library/nginx'",
    branches: 'Branche',
    branchesHint: 'Obserwowane branche (tagi OCI), rozdzielone przecinkami — np. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Rozwiązywany TERAZ: pull pobiera digest, na który branch wskazuje dzisiaj.',
    refresh: 'Odśwież',
    deleteRepository: 'Usuń repozytorium',
    reflogCount: '{n} poprzednich',
    noResolutions: 'Nigdy nieodświeżone — brak obserwowanych rozwiązań.',
    refreshFailed: 'Ostatnie odświeżenie nieudane ({when})',
    loadError: 'Nie można wczytać repozytoriów.',
    reference: 'Odwołanie',
    digest: 'Digest',
    digestHint: 'sha256:… — dokładny obraz, bez brancha (detached)',
    size: 'Rozmiar',
    nodes: 'Węzły',
    detached: 'detached',
    detachedHint: 'Pobrany po digeście, bez brancha — kontrola driftu nie ma zastosowania.',
    pulledAt: 'Pobrany',
    pull: 'Pull',
    pullTitle: 'Pull obrazu',
    pullHint: 'Pre-warming, nigdy warunek konieczny: pull po branchu rozwiązuje TERAZ i pobiera TEN digest; pull po digeście jest detached.',
    pullError: 'Pull został odrzucony',
    pullMode: 'Pull po',
    pullModeBranch: 'Branchu (rozwiąż teraz)',
    pullModeDigest: 'Digeście (detached)',
    pullModeBranchHint: 'Uczciwa wartość domyślna: jak apt install — wykonany później może dać inny obraz.',
    pullModeDigestHint: 'Dokładny digest — powtarzalność i rollback; rezygnacja z kontroli driftu.',

    // Wzorzec dwóch przycisków (#88, ratyfikacja 2026-07-30 wieczorem): "z
    // registry" to istniejący, prowadzony pull, "z katalogu" materializuje
    // gotowe archiwum oci-image (droga air-gapped).
    importFromRegistry: 'Importuj z registry',
    importFromCatalog: 'Importuj z katalogu',
    importCatalogTitle: 'Importuj obraz OCI z katalogu',
    importCatalogHint: 'Droga air-gapped: gotowe archiwum oci-image (tar/tar.gz — docker-archive lub oci-archive) zostaje zmaterializowane w magazynie obrazów pod odwołaniem catalog/<katalog>/<plik>@<digest>; aplikacje konsumują je jak każdy inny obraz. Archiwa wgrywa się do katalogów — ta sekcja tylko importuje.',
    importCatalogFile: 'Archiwum',
    importCatalogFileHint: 'Gotowe pliki oci-image z wybranego katalogu.',
    importCatalogNoFiles: 'Brak gotowych archiwów oci-image w tym katalogu — należy wgrać jakieś ze szczegółów katalogu.',
    importCatalogError: 'Import został odrzucony',
    registry: 'Registry',
    repository: 'Repozytorium',
    cacheMissing: 'Cache OCI klastra nie jest skonfigurowana — pulle są odrzucane, dopóki nie zostanie ustawiona pula storage.',
    setCache: 'Ustaw cache',
    setCacheTitle: 'Skonfiguruj cache OCI',
    setCacheHint: 'DOMYŚLNA pula na poziomie klastra, która przechowuje bloby pobranych obrazów — scope może to nadpisać własną pulą (strona Scope). Zmiana nie działa na gorąco, niczego nie restartuje i nie przenosi blobów: pojawiają się one leniwie przy następnym starcie/użyciu.',
    cachePool: 'Pula storage',
    changeCache: 'Zmień cache',
    changeCacheTitle: 'Zmień pulę cache OCI',
    cacheCurrent: 'Cache OCI klastra (domyślna): {name}',
    sectionOverview: 'Przegląd',
    sectionRepositories: 'Repozytoria',
    sectionExplore: 'Eksploruj',
    exploreHint: 'Zdalne wyszukiwanie na żywo w registry — dla Docker Hub pełne (opis, pobrania, gwiazdki), u innych dostawców best-effort. Po wybraniu wyniku można przeczytać jego pełny opis i przejrzeć zdalne tagi; z tagu da się dodać odwołanie do repozytorium TVirt.',
    exploreSearch: 'Szukaj',
    exploreUnsupported: 'Ten dostawca nie obsługuje wyszukiwania.',
    exploreNoResult: 'Brak pasujących repozytoriów.',
    exploreNoTags: 'Brak pasujących tagów w tym repozytorium.',
    exploreOfficial: 'Oficjalne',
    explorePulls: 'Pobrania',
    exploreStars: 'Gwiazdki',
    exploreUpdated: 'Zaktualizowano {when}',
    exploreLoadMore: 'Wczytaj więcej',
    exploreSelectHint: 'Po wybraniu wyniku wczytają się tutaj pełny opis i zdalne tagi.',
    exploreNoDescription: 'Ten dostawca nie udostępnia żadnego opisu.',
    exploreTagsTitle: 'Zdalne tagi',
    exploreTagFilter: 'Szukaj tagu',
    exploreAddToRepo: 'Dodaj do repozytorium',
    exploreAdded: '{path}:{tag} jest teraz śledzony — patrz sekcja Repozytoria.',
    addBranch: 'Dodaj branch',
    purgeRequiredTitle: "Usunąć '{name}' wraz z jego obrazami?",
    purgeRequiredBody: 'Żadna aplikacja nie używa tego repozytorium, ale wciąż istnieją pobrane obrazy: usunięcie kasuje też ich wpisy, a bloby w cache przechodzą do garbage collectora.',
    purgeConfirm: 'Usuń także obrazy',
    providerSelectHint: 'Wybierz typ registry: karta opowiada preset i zastosowanie.',
    providerDesc: {
      dockerhub: 'Publiczne registry Dockera: URL wstępnie wypełniony, pełne wyszukiwanie z opisami i licznikami.',
      ghcr: 'GitHub Container Registry: URL wstępnie wypełniony; konta używają personal access tokena.',
      ecr: 'Amazon Elastic Container Registry: endpointy per konto/region — URL trzeba podać.',
      quay: 'Registry Red Hat Quay: URL wstępnie wypełniony.',
      generic: 'Registry self-hosted (Harbor, registry:2, …): URL https:// jest obowiązkowy.'
    },

    // Dialog standardowy (runda #156): pola szczegółów obrazu/registry,
    // których nie pokazywały kolumny.
    layerCount: 'Warstwy',
    verifiedAt: 'Ostatnia weryfikacja',
    verifyOk: 'Wynik',
    verifyMessage: 'Komunikat weryfikacji',

    // Model #348/R39: obraz TO digest — treść — a registry, repozytorium i gałąź to NAZWY, które do niego prowadzą.
    head: 'Head',
    heads: 'Głowy według architektury',
    listDigest: 'Digest listy',
    neverResolved: 'Nigdy nierozwiązany',
    totalSize: 'Rozmiar łączny',
    reflogTitle: 'Historia rozwiązań',
    usedBy: 'Używany przez',
    usageLockfile: 'lockfile',
    usageRunning: 'uruchomiony',
    evictable: 'do usunięcia',
    evict: 'Usuń z cache',
    evictHeadTitle: 'Usunąć {digest}?',
    evictHeadBody: 'To bieżące rozwiązanie co najmniej jednego kolektora: usunięcie jest dozwolone — to tylko cache, zdalny branch nadal go serwuje — ale nie może się zdarzyć przez pomyłkę. Blob jest JEDEN: usunięcie opróżnia wszystkie kolektory, które go współdzielą.',
    evictConfirm: 'Usuń mimo to',

    arch: 'Architektura',
    names: 'Nazwy',
    noNames: 'bez nazwy',
    views: 'Widoki',
    lastView: 'ostatni widok',
    evictLastViewTitle: 'Usunąć ostatnie odwołanie do {digest}?',
    evictLastViewBody: 'To ostatni widok tej treści: po jego usunięciu obraz przestaje istnieć w TVirt, a bajty ({size}) zostają zwolnione. To docker image rm tego modelu — nie efekt uboczny, lecz sama operacja.',
    branchesTabHint: 'Obserwowane gałęzie tego repozytorium: dla każdej dzisiejsze głowy — po jednej na architekturę — chronologia odświeżeń i ile z nazwanych przez nią obrazów jest w pamięci podręcznej. Odświeżenie to «git fetch» repozytorium: rozwiązuje wszystkie gałęzie naraz.',
    noBranches: 'W tym repozytorium nie jest obserwowana żadna gałąź.',
    stopObserving: 'Przestań obserwować gałąź',
    pullBranch: 'Pobierz do cache głowę brancha (refresh rozwiązuje, to pobiera)',
    pullDigest: 'Pobierz do cache ten digest',
    imageCount: 'Obrazy',
    deleteBranchPurgeTitle: 'Zostawić obrazy {name} bez nazwy?',
    deleteBranchPurgeBody: 'Żadna aplikacja nie nazywa tej gałęzi, ale niektóre obrazy są osiągalne tylko przez nią: po jej usunięciu zostaną w pamięci podręcznej bez nazwy, wypisane wśród obrazów repozytorium i usuwalne ręcznie.',
    deleteBranchPurgeConfirm: 'Usuń i zostaw obrazy bez nazwy',
    imagesTabHint: 'Obrazy tego repozytorium — treści, czyli digesty — widoczne także bez wybierania gałęzi. Obraz jest unikalny w klastrze: nazw, które do niego prowadzą, może być kilka.',
    noImages: 'Żaden obraz tego repozytorium nie jest zmaterializowany w pamięci podręcznej.',
    deleteRepositoryTitle: 'Usunąć {name}?',
    deleteRepositoryBody: 'Repozytorium i jego gałęzie znikają wraz z chronologią. Obrazy zostają w pamięci podręcznej: tracą tylko tę nazwę. Repozytorium nazywanego przez aplikację nie da się usunąć.',
    provenanceCatalog: 'katalog',
    refreshedAt: 'Odświeżono',
    neverRefreshed: 'Nigdy nie odświeżano',
    sectionBranches: 'Gałęzie',
    sectionImages: 'Obrazy',
    repositoriesGovernedElsewhere: 'Tutaj repozytoria się tylko ogląda: rejestrowanie, odświeżanie, obserwowanie gałęzi i usuwanie obrazów odbywa się w sekcji Obrazy OCI.',
    gotoImages: 'Przejdź do Obrazów OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pody',
    containers: 'Kontenery',
    instances: 'Instancje',
    instancesTooltip: '{running} działa, {error} z błędem',
    placement: 'Rozmieszczenie',
    spread: 'rozłożenie',
    ha: 'HA',
    templateRevision: 'rewizja',
    deleting: 'Usuwanie',
    empty: 'Brak podów — utwórz aplikację (jeden kontener) lub pod z CLI (create-pod).',
    openInstances: 'Otwórz instancje',
    rollingRestart: 'Restart kroczący',
    scale: 'Skaluj',
    scaleTitle: 'Skaluj {name}',
    scaleHint: 'Liczba instancji (0–64): w górę zajmowany jest najniższy wolny numer porządkowy, w dół wycofywany najwyższy, a jego dane trwałe pozostają.',
    scaleError: 'Skalowanie nie powiodło się',
    replicas: 'Repliki',
    deleteRunningError: '{name} działa — najpierw go zatrzymaj.',
    deleteInstancesIntro: 'Wszystkie {count} instancje zostaną usunięte.',
    stateRunning: 'Działa',
    stateStopped: 'Zatrzymany',
    editor: {
      createTitle: 'Utwórz Pod',
      create: 'Utwórz Pod',
      editTitle: 'Edytuj Pod',
      nameHint: 'DNS-1123, najwyżej 58 znaków — instancje nazywają się <nazwa>-<indeks>; niezmienne po utworzeniu.',
      restartPolicy: 'Polityka restartu',
      restartPolicyHint_always: 'Węzeł restartuje każdy zakończony kontener, z wykładniczym backoffem (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Restartowany jest tylko kontener zakończony kodem różnym od zera; wyjście 0 pozostaje w spoczynku.',
      restartPolicyHint_never: 'Zakończony kontener zostaje jak jest — instancja kończy jako succeeded lub failed.',
      grace: 'Karencja (s)',
      graceHint: 'Granica SIGTERM → SIGKILL zatrzymania.',
      hostname: 'Nazwa hosta',
      hostnameHint: 'Puste = nazwa instancji.',
      hostnameDefault: 'nazwa instancji',
      sharePid: 'Współdziel przestrzeń nazw PID między kontenerami',
      containersIntro: 'Kontenery init wykonują się do końca, po kolei, zanim wystartują kontenery; kontenery współdzielą sieć instancji (jeden IP, localhost między nimi).',
      initContainers: 'Kontenery init',
      initAdd: 'Dodaj kontener init',
      initHint: 'Każdy musi zakończyć się kodem 0; niepowodzenie stawia instancję w błędzie, a węzeł ponawia z backoffem.',
      containerAdd: 'Dodaj kontener',
      atLeastOne: 'Pod potrzebuje co najmniej jednego kontenera.',
      duplicateNames: 'Nazwy kontenerów muszą być unikalne w Podzie (łącznie z kontenerami init).',
      containerName: 'Nazwa kontenera',
      containerInvalid: 'Ten kontener jest niekompletny: nazwa (DNS-1123), obraz, montowania na zadeklarowanych wolumenach, liczbowe limity i sonda.',
      command: 'Polecenie',
      commandHint: 'Zastępuje entrypoint obrazu — jeden argument na wiersz, nigdy ciąg powłoki.',
      args: 'Argumenty',
      argsHint: 'Jeden na wiersz (CMD obrazu, gdy puste).',
      mounts: 'Montowania',
      mountAdd: 'Dodaj montowanie',
      mountNoVolumes: 'Najpierw zadeklaruj wolumen w karcie Pamięć.',
      readOnly: 'tylko do odczytu',
      resources: 'Limity',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (np. 1.5)',
      memory: 'Pamięć (MiB)',
      memoryHint: 'podman --memory',
      health: 'Sonda żywotności',
      healthCmd: 'Polecenie sondy',
      healthCmdHint: 'Uruchamiane w kontenerze przez węzeł przy każdym tiku nadzoru — jeden argument na wiersz; wyjście 0 = zdrowy.',
      healthTimeout: 'Limit czasu (s)',
      healthRetries: 'Ponowienia',
      healthRetriesHint: 'Kolejne niepowodzenia, zanim węzeł zrestartuje kontener.',
      ips: 'Adresy statyczne',
      ipsHint: 'Jeden na instancję, w kolejności porządkowej — skalowanie poza listę jest odrzucane.',
      instance: 'instancja',
      volumesHint: 'Wolumeny należą do Poda; ścieżka montowania do każdego kontenera (karta Kontenery).',
      spread: 'Rozproszenie',
      spreadHint_preferred: 'Instancje na różnych węzłach, gdy to możliwe.',
      spreadHint_required: 'Instancje na różnych węzłach, inaczej skalowanie odmawia.',
      spreadHint_none: 'Tylko decydent.',
      ha: 'Wysoka dostępność (opt-in)',
      haHint: 'Każdy trwały element na współdzielonym storage; jeśli węzeł umrze, decider HA odtwarza instancje na innym członku (automatyczny failover, jak w VM HA).',
      yes: 'tak',
      no: 'nie'
    },
    detail: {
      container: 'Kontener',
      actions: 'Akcje',
      ready: 'Gotowy',
      notReady: 'Niegotowy',
      restarts: 'Restarty',
      lastRestartAt: 'Ostatni restart:',
      backoffUntil: 'Ponowienie o',
      stateAbsent: 'brak',
      stateRunning: 'działa',
      stateTerminated: 'zakończony',
      stateWaiting: 'oczekuje',
      init: 'init',
      noInstances: 'Brak instancji (repliki 0).',
      ha: 'HA',
      haHint: 'Automatyczny failover: jeśli węzeł umrze, decider HA odtwarza instancję na innym członku (każdy trwały element na współdzielonym storage).',
      authority: 'Authority (węzeł)',
      homeless: 'bez authority',
      homelessHint: 'Przywrócenie z checkpointu pomija authority (#380): żaden węzeł jej nie obsługuje, dopóki nie przeskalujesz Poda (choćby do tej samej liczby replik).',
      restartContainer: 'Zrestartuj tylko ten kontener (pod pozostaje uruchomiony)',
      divergingHint: 'Pożądany stan tej instancji odbiega od domyślnego stanu Poda (PD-P19).',
      revisionLag: 'rewizja {applied} zastosowana z {current}',
      updatedInstances: '{updated}/{desired} instancji na tej rewizji'
    }
  }
}
